export default __webpack_public_path__ + "static/media/UserGuide_nl_NL.5dba937a.pdf";